import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';

import type { RegisterAnalytics } from '~features/annals';
import { GTMAnalytics } from '~services/analytics';
import { authApi } from '~services/api/auth';
import { locationApi } from '~services/api/location';
import { userApi } from '~services/api/user';

import type { RootState } from '../index';
import {
	AppOpenedFromEmailAction,
	EMAIL_CONFIRMED,
	EmailConfirmedAction,
} from '../utils/track-email-redirect-event';

export const trackingMiddleware = createListenerMiddleware();

let afid: string | undefined;
let analytics: RegisterAnalytics | undefined;

trackingMiddleware.startListening({
	matcher: isAnyOf(AppOpenedFromEmailAction, EmailConfirmedAction),
	effect: async (action, listenerApi) => {
		if (typeof window === 'undefined') {
			return;
		}

		const {
			auth: {
				info: { id, email },
			},
		} = listenerApi.getState() as RootState;

		const { data: geoData } = await listenerApi.dispatch(
			locationApi.endpoints.getLocation.initiate({})
		);
		const { data: userData } = await listenerApi.dispatch(
			userApi.endpoints.userInfo.initiate({ id })
		);

		afid = action.payload as string;
		if (action.type === EMAIL_CONFIRMED) {
			GTMAnalytics.userConfirmedEmail(
				action.payload,
				email,
				userData?.birthday,
				userData?.gender,
				geoData?.country
			);
		}
		GTMAnalytics.userRedirectedFromNotification(
			action.payload,
			email,
			userData?.birthday,
			userData?.gender,
			geoData?.country
		);
	},
});

let registrationMethod = '';

trackingMiddleware.startListening({
	matcher: isAnyOf(
		authApi.endpoints.register.matchFulfilled,
		authApi.endpoints.registerGoogle.matchFulfilled
	),
	effect: (action) => {
		if (typeof window === 'undefined') {
			return;
		}

		// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
		analytics = action.meta.arg.originalArgs.analytics as
			| RegisterAnalytics
			| undefined;
		// eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
		registrationMethod = action.meta.arg.endpointName.includes('Google')
			? 'google'
			: 'email';
	},
});

trackingMiddleware.startListening({
	matcher: userApi.endpoints.editUserInfo.matchPending,
	effect: (action) => {
		if (typeof window === 'undefined') {
			return;
		}
		if (registrationMethod) {
			const rm = registrationMethod;
			registrationMethod = '';
			const { birthday, name } = action.meta.arg.originalArgs.data;
			GTMAnalytics.userSignedUp(rm, afid, birthday, name, analytics?.outbound);
			GTMAnalytics.generateLead(afid, analytics?.outbound);
		}
	},
});
